import {createContext, use} from 'react'

export const RootElementContext = createContext<HTMLElement | undefined>(undefined)

export function useRootElement() {
  const rootElement = use(RootElementContext)
  return rootElement
}
